import { render, staticRenderFns } from "./PromoCodesList.vue?vue&type=template&id=0af123cc&"
import script from "./PromoCodesList.vue?vue&type=script&lang=js&"
export * from "./PromoCodesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports